import { render } from "./SearchArtist.vue?vue&type=template&id=f73d909a&scoped=true"
import script from "./SearchArtist.vue?vue&type=script&lang=js"
export * from "./SearchArtist.vue?vue&type=script&lang=js"

import "./SearchArtist.vue?vue&type=style&index=0&id=f73d909a&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73d909a"]])

export default __exports__